interface ImageCardProps {
  src: string
  alt: string
  isSquare?: boolean
  className?: string
  withGlow?: boolean
}

const ImageCard = ({ src, alt, isSquare = false, className = '', withGlow = false }: ImageCardProps) => {
  return (
    <div className={`relative ${className}`}>
      {withGlow && (
        <div className="absolute inset-0 -m-2">
          <div 
            className="w-full h-full rounded-2xl"
            style={{
              backgroundImage: `url(${src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'blur(18px) saturate(1.5)',
              transform: 'scale(1.003)',
              opacity: 0.5
            }}
          />
        </div>
      )}
      <div className="relative overflow-hidden">
        <img
          src={src}
          alt={alt}
          className="w-full h-auto object-contain"
          loading="lazy"
          style={isSquare ? { aspectRatio: '1/1' } : undefined}
        />
      </div>
    </div>
  )
}

export default ImageCard 